// src/index.tsx
import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom';
import { SORTED_ROUTES } from './AppRoutes';
import reportWebVitals from './reportWebVitals';
import axios from 'axios';
import AuthStateProvider, { useAuthContext } from './auth/AuthStateProvider';
import { AppContainer } from './AppContainer';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Login from './pages/login/Login';
import ProtectedContent from './auth/ProtectedRoute';

// Lazy — these aren't on the critical path for the typical landed-on-/-while-
// authenticated render, so split them out of the initial bundle.
const Signup = lazy(() => import('./pages/login/Signup'));
const PublicMenuView = lazy(() => import('./pages/menus/PublicMenuView'));
const SharedMenuEdit = lazy(() => import('./pages/menus/SharedMenuEdit'));
const PublicCocktailView = lazy(() => import('./pages/cocktails/PublicCocktailView'));

axios.defaults.withCredentials = true
if (process.env.REACT_APP_API_URL) {
    axios.defaults.baseURL = process.env.REACT_APP_API_URL
} else if (process.env.NODE_ENV == "production") {
    // Derive the API host from the page's hostname so the same JS bundle
    // works on every brand host wired up in apps.yaml. Strip a leading "www."
    // and assume the API lives at `api.<host>`. Hosts themselves are defined
    // in ../../platform/apps.yaml — no list to keep in sync here.
    const host = window.location.hostname.replace(/^www\./, '');
    axios.defaults.baseURL = `${window.location.protocol}//api.${host}`
} else {
    axios.defaults.baseURL = "http://localhost:4000"
}
console.log('Using base URL: ' +axios.defaults.baseURL)

ReactDOM.render(
    <React.StrictMode>
        <AuthStateProvider>
            <AppContainer>
                <Router basename={process.env.PUBLIC_URL}>
                    <Suspense fallback={null}>
                            <Routes>
                                {/* Public routes (anonymous-readable) */}
                                {SORTED_ROUTES.filter(p => p.isPublic).map(props => (
                                    <Route
                                    key={props.path}
                                    path={props.path}
                                    element={
                                        <ProtectedContent isPublic roles={props.roles}>
                                        {props.children}
                                        </ProtectedContent>
                                    }
                                    />
                                ))}
                                {/* Auth-gated routes */}
                                <Route element={<ProtectedContent roles={['admin', 'standard']} />}>
                                    {SORTED_ROUTES.filter(p => !p.isPublic).map(props => (
                                        <Route
                                        key={props.path}
                                        path={props.path}
                                        element={
                                            <ProtectedContent roles={props.roles}>
                                            {props.children}
                                            </ProtectedContent>
                                        }
                                        />
                                    ))}
                                </Route>

                                <Route path="/login" element={<Login />} />
                                <Route path="/signup" element={<Signup />} />
                                <Route path="/shared/cocktail/:userId/:cocktailId" element={<PublicCocktailView />} />
                                <Route path="/shared/menu/:userId/:menuId/cocktail/:cocktailId" element={<PublicCocktailView />} />
                                <Route path="/shared/menu/:userId/:menuId/edit" element={<SharedMenuEdit />} />
                                <Route path="/shared/menu/:userId/:menuId" element={<PublicMenuView />} />
                            </Routes>
                    </Suspense>
                </Router>
            </AppContainer>
        </AuthStateProvider>
    </React.StrictMode>,
    document.getElementById('root')
);

reportWebVitals();